import { OAuth2Client } from '@gaoding/oauth2-client';
import { getConfig } from './config';
var client;
export function createOAuth2Client() {
  if (!client) {
    client = new OAuth2Client({
      env: getConfig('env'),
      clientId: getConfig('clientId'),
      clientSecret: getConfig('clientSecret'),
      redirectURI: getConfig('redirectURI'),
      authorizationEndpoint: getConfig('authorizationEndpoint'),
      bizCode: getConfig('bizCode'),
      sso: getConfig('sso'),
      ssoRedirectURI: getConfig('ssoRedirectURI')
    });
  }

  return client;
}